module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow_next-6d0a2f61e9f0e4262d2d4f52dacea7d4.svg";